import NewAdminNotice from "./styles";
import { NEW_ADMIN_URL } from "./model";

export default NewAdminNotice;

export { NewAdminNotice, NEW_ADMIN_URL };
